
import { Component, Prop } from 'vue-property-decorator';
import DashboardBlock from './DashboardBlock.vue';

@Component
export default class DashboardCallToActionBlock extends DashboardBlock {
  @Prop(Object)
  block!: any;

  get image(): string {
    return !this.block.multinational
      ? // @ts-ignore
        this.$helpers.getApiImageThumbnail(this.block.image)
      : this.block.image;
  }
}
